/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react'

import classNames from 'classnames'
import AnimateHeight from 'react-animate-height'

import classes from './AccordionItem.module.scss'
import { AccordionItemType } from './types'

const text =
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur nec arcu ac dui egestas mattis. Integer sem leo, sollicitudin at pulvinar interdum, congue sed leo. Curabitur et imperdiet nisl. Maecenas efficitur felis nisl. Morbi aliquet facilisis mattis. Fusce auctor nec leo eget imperdiet. Vivamus faucibus urna nec sem euismod mattis. '

class AccordionItem extends Component<
  AccordionItemType & React.HTMLAttributes<HTMLElement>
> {
  state = {
    opened: false,
  }

  render(): JSX.Element {
    const {
      props: { title, children, paragraph, htmlTitle, className, descr },
      state: { opened },
    } = this
    const accordionItemClass = classNames([
      classes['accordion-item'],
      className,
      {
        [classes['accordion-item--opened']]: opened,
      },
    ])
    return (
      <div className={accordionItemClass}>
        <div
          className={classes['accordion-item__line']}
          onClick={() => {
            this.setState({ opened: !opened })
          }}
        >
          <div className={classes['accordion-item__title']}>
            {htmlTitle || title}
            {descr && (
              <div className={classes['accordion-item__title--descr']}>
                {descr}
              </div>
            )}
          </div>

          <i className={`icon-arrow-down ${classes['accordion-item__icon']}`} />
        </div>

        <div className={classes['accordion-item__inner']}>
          <AnimateHeight height={opened ? 'auto' : 0} duration={300}>
            <div className={classes['accordion-item__content']}>
              {paragraph || children || text}
            </div>
          </AnimateHeight>
        </div>
      </div>
    )
  }
}

export default AccordionItem
